// components/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
    const { currentUser, isAdmin } = useAuth();

    if (!currentUser) {
        // Redirect to login if not authenticated
        return <Navigate to="/login" replace />;
    }

    if (requireAdmin && !isAdmin()) {
        // Redirect to home if not admin
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;